// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from Separator.module.scss  */
.Separator-module-Root_1bM {
  position: relative;
  z-index: 1; }

.Separator-module-Line_36_ {
  width: 100%;
  margin: 0 auto; }
  .Separator-module-Line_36_.Separator-module-thinThickness_1Vt {
    height: 1px; }
  .Separator-module-Line_36_.Separator-module-thickThickness_2qM {
    height: 2px; }
  .Separator-module-Line_36_.Separator-module-shortWidth_31v {
    max-width: 230px; }
  .Separator-module-Line_36_.Separator-module-middleWidth_25d {
    max-width: 954px; }
  .Separator-module-Line_36_.Separator-module-longWidth_3DQ {
    max-width: 100%; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Separator/Separator.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,UAAU,EAAE;;AAEd;EACE,WAAW;EACX,cAAc,EAAE;EAChB;IACE,WAAW,EAAE;EACf;IACE,WAAW,EAAE;EACf;IACE,gBAAgB,EAAE;EACpB;IACE,gBAAgB,EAAE;EACpB;IACE,eAAe,EAAE","sourcesContent":["/*  imported from Separator.module.scss  */\n.Separator-module-Root_1bM {\n  position: relative;\n  z-index: 1; }\n\n.Separator-module-Line_36_ {\n  width: 100%;\n  margin: 0 auto; }\n  .Separator-module-Line_36_.Separator-module-thinThickness_1Vt {\n    height: 1px; }\n  .Separator-module-Line_36_.Separator-module-thickThickness_2qM {\n    height: 2px; }\n  .Separator-module-Line_36_.Separator-module-shortWidth_31v {\n    max-width: 230px; }\n  .Separator-module-Line_36_.Separator-module-middleWidth_25d {\n    max-width: 954px; }\n  .Separator-module-Line_36_.Separator-module-longWidth_3DQ {\n    max-width: 100%; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
